<app-d-form-group [formArray]="formArray" [dependentValidities]="dependentValidities" [defaultValues]="reviewComments" (submit)="onSubmit($event)" (cancel)="onCancel($event)"
 [disable]="disable" (control)="onControlChange($event)"></app-d-form-group>
